// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { API } from "../../../config/api";
// import { get, del, put } from "../../../lib/http"; // 👈 delete aur update ke liye

// export default function AdminBanner() {
//   const navigator = useNavigate();
//   const [showConfirm, setShowConfirm] = useState(false);
//   const [selectedBanner, setSelectedBanner] = useState(null);
//   const [banners, setBanners] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // Fetch banners
//   useEffect(() => {
//     let isMounted = true;
//     const fetchBanners = async () => {
//       try {
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const res = await get(API.banner.list, {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//             "Content-Type": "application/json",
//           },
//         });
//         if (isMounted && Array.isArray(res)) {
//           setBanners(res);
//         }
//       } catch (err) {
//         console.error("getAllBanners error:", err);
//       }
//     };
//     fetchBanners();
//     return () => {
//       isMounted = false;
//     };
//   }, []);

//   // Add Banner
//   const handleAddBanner = () => {
//     navigator("/admin/banners/new");
//   };

//   // Edit Banner
//   const handleEdit = (banner) => {
//     navigator(`/admin/banners/edit/${banner._id}`); // 👈 edit page pe bhej do
//   };

//   // Delete Banner
//   const handleDelete = async (banner) => {
//     if (!window.confirm(`Are you sure you want to delete ${banner.title}?`)) return;

//     try {
//       setLoading(true);
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//       await del(`${API.banner.delete}/${banner._id}`, {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//           "Content-Type": "application/json",
//         },
//       });

//       setBanners(banners.filter((b) => b._id !== banner._id)); // UI update
//       alert(`✅ Deleted: ${banner.title}`);
//     } catch (err) {
//       console.error("Delete error:", err);
//       alert("Failed to delete banner.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Toggle Active / Inactive
//   const handleToggleStatus = (banner) => {
//     setSelectedBanner(banner);
//     setShowConfirm(true);
//   };

//   const confirmToggle = async () => {
//     if (selectedBanner) {
//       try {
//         setLoading(true);
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const updated = await put(`${API.banner.update}/${selectedBanner._id}`, {
//           isActive: !selectedBanner.isActive,
//         }, {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//             "Content-Type": "application/json",
//           },
//         });

//         // UI update
//         setBanners((prev) =>
//           prev.map((b) =>
//             b._id === updated._id ? { ...b, isActive: updated.isActive } : b
//           )
//         );
//         alert(
//           `✅ ${selectedBanner.title} is now ${
//             selectedBanner.isActive ? "Inactive" : "Active"
//           }`
//         );
//       } catch (err) {
//         console.error("Toggle error:", err);
//         alert("Failed to update status.");
//       } finally {
//         setLoading(false);
//         setShowConfirm(false);
//         setSelectedBanner(null);
//       }
//     }
//   };

//   return (
//     <div className="p-6">
//       {/* Header */}
//       <div className="flex justify-between items-center mb-6">
//         <h2 className="text-2xl font-semibold">Banner List</h2>
//         <button
//           onClick={handleAddBanner}
//           className="px-5 py-2 rounded-2xl inline-flex items-center mt-6 rounded-full bg-gradient-to-r from-yellow-400 to-yellow-500 px-6 py-3 text-base font-semibold text-gray-900 hover:from-yellow-500 hover:to-yellow-600 transition-all duration-300"
//         >
//           + Add New Banner
//         </button>
//       </div>

//       {/* Loader */}
//       {loading && <p className="text-blue-600 font-medium mb-4">⏳ Processing...</p>}

//       {/* Banner cards */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//         {banners.map((banner) => (
//           <div
//             key={banner._id}
//             className="bg-white rounded-2xl shadow-md hover:shadow-lg transition p-4 flex flex-col"
//           >
//             <img
//               src={banner.imageUrl}
//               alt={banner.title}
//               className="w-full h-40 object-cover rounded-xl"
//             />
//             <div className="mt-3 flex-1">
//               <h3 className="text-lg font-bold">{banner.title}</h3>
//               <p className="text-sm text-gray-500 capitalize">Type: {banner.type}</p>
//               <span
//                 className={`inline-block mt-2 px-3 py-1 text-xs font-medium rounded-full ${
//                   banner.isActive
//                     ? "bg-green-100 text-green-600"
//                     : "bg-red-100 text-red-600"
//                 }`}
//               >
//                 {banner.isActive ? "Active" : "Inactive"}
//               </span>
//             </div>

//             {/* Actions */}
//             <div className="flex justify-end gap-3 mt-4">
//               <button
//                 onClick={() => handleEdit(banner)}
//                 className="px-3 py-1 rounded-xl bg-yellow-100 text-yellow-700 text-sm font-medium hover:bg-yellow-200 transition"
//               >
//                 ✏️ Edit
//               </button>
//               <button
//                 onClick={() => handleDelete(banner)}
//                 className="px-3 py-1 rounded-xl bg-red-100 text-red-700 text-sm font-medium hover:bg-red-200 transition"
//               >
//                 🗑 Delete
//               </button>
//               <button
//                 onClick={() => handleToggleStatus(banner)}
//                 className={`px-3 py-1 rounded-xl text-sm font-medium transition ${
//                   banner.isActive
//                     ? "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     : "bg-green-100 text-green-700 hover:bg-green-200"
//                 }`}
//               >
//                 {banner.isActive ? "Deactivate" : "Activate"}
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Confirmation Modal */}
//       {showConfirm && selectedBanner && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-2xl shadow-lg w-96 text-center">
//             <h3 className="text-lg font-semibold mb-3">Are you sure?</h3>
//             <p className="text-sm text-gray-600 mb-6">
//               Do you really want to{" "}
//               <span className="font-medium">
//                 {selectedBanner.isActive ? "deactivate" : "activate"}
//               </span>{" "}
//               <br /> "{selectedBanner.title}" ?
//             </p>
//             <div className="flex justify-center gap-4">
//               <button
//                 onClick={() => setShowConfirm(false)}
//                 className="px-4 py-2 rounded-xl bg-gray-100 text-gray-700 hover:bg-gray-200 transition"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={confirmToggle}
//                 className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition"
//               >
//                 Yes, Sure
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


// src/pages/admin/banners/AdminBanner.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../../../config/api";
import { get, del, put } from "../../../lib/http";
import { AD } from "../../adminUi.js";

const cn = (...a) => a.filter(Boolean).join(" ");

export default function AdminBanner() {
  const navigate = useNavigate();

  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState("");

  // filters
  const [q, setQ] = useState("");
  const [type, setType] = useState("all");      // hero | promo | category | ...
  const [status, setStatus] = useState("all");  // active | inactive | all
  const [sort, setSort] = useState("latest");   // latest | oldest | az | za

  // confirm modal
  const [confirm, setConfirm] = useState({ open: false, id: null, name: "", nextActive: false });

  /* ───────────────────────── fetch ───────────────────────── */
  const fetchBanners = async () => {
    setLoading(true);
    setError("");
    try {
      const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
      const res = await get(API.banner.list, {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
          "Content-Type": "application/json",
        },
      });
      setBanners(Array.isArray(res) ? res : []);
    } catch (err) {
      console.error("getAllBanners error:", err);
      setError("Failed to load banners.");
      setBanners([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  /* ─────────────── derived options (types) ─────────────── */
  const typeOptions = useMemo(() => {
    const t = new Set();
    banners.forEach((b) => b?.type && t.add(String(b.type)));
    return ["all", ...Array.from(t).sort()];
  }, [banners]);

  /* ───────────── client filter + sort view ─────────────── */
  const view = useMemo(() => {
    let list = [...banners];

    // search
    const term = q.trim().toLowerCase();
    if (term) {
      list = list.filter((b) =>
        [b?.title, b?.type]
          .filter(Boolean)
          .some((v) => String(v).toLowerCase().includes(term))
      );
    }

    // type
    if (type !== "all") {
      list = list.filter((b) => String(b?.type || "").toLowerCase() === type.toLowerCase());
    }

    // status
    if (status !== "all") {
      const want = status === "active";
      list = list.filter((b) => Boolean(b?.isActive) === want);
    }

    // sort
    list.sort((a, b) => {
      const aName = (a?.title || "").toLowerCase();
      const bName = (b?.title || "").toLowerCase();
      const aDate = new Date(a?.updatedAt || a?.createdAt || 0).getTime();
      const bDate = new Date(b?.updatedAt || b?.createdAt || 0).getTime();
      switch (sort) {
        case "latest": return bDate - aDate;
        case "oldest": return aDate - bDate;
        case "az": return aName.localeCompare(bName);
        case "za": return bName.localeCompare(aName);
        default: return 0;
      }
    });

    return list;
  }, [banners, q, type, status, sort]);

  /* ───────────── actions ───────────── */
  const handleAddBanner = () => navigate("/admin/banners/new");
  const handleEdit = (banner) => navigate(`/admin/banners/edit/${banner._id}`);

  const handleDelete = async (banner) => {
    // nicer confirm modal instead of window.confirm
    setConfirm({ open: true, id: banner._id, name: banner.title, nextActive: banner.isActive });
  };

  const confirmDelete = async () => {
    if (!confirm.id) return;
    try {
      setBusyId(confirm.id);
      const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
      await del(`${API.banner.delete}/${confirm.id}`, {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
          "Content-Type": "application/json",
        },
      });
      setBanners((prev) => prev.filter((b) => b._id !== confirm.id));
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete banner.");
    } finally {
      setBusyId(null);
      setConfirm({ open: false, id: null, name: "", nextActive: false });
    }
  };

  const handleToggleAsk = (banner) => {
    setConfirm({
      open: true,
      id: banner._id,
      name: banner.title,
      nextActive: !banner.isActive,
    });
  };

  const confirmToggle = async () => {
    if (!confirm.id) return;
    try {
      setBusyId(confirm.id);
      const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
      const updated = await put(
        `${API.banner.update}/${confirm.id}`,
        { isActive: confirm.nextActive },
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
            "Content-Type": "application/json",
          },
        }
      );
      setBanners((prev) =>
        prev.map((b) =>
          b._id === updated._id ? { ...b, isActive: updated.isActive } : b
        )
      );
    } catch (err) {
      console.error("Toggle error:", err);
      alert("Failed to update status.");
    } finally {
      setBusyId(null);
      setConfirm({ open: false, id: null, name: "", nextActive: false });
    }
  };

  /* ───────────── UI ───────────── */
  return (
    <div className={AD.page}>
      {/* Title bar */}
      <div className={AD.headerRow}>
        <div>
          <h1 className={AD.title}>Banners</h1>
          <p className={AD.subtitle}>
            Create, edit and manage homepage banners
          </p>
        </div>
        <div className={AD.toolbar}>
          <button type="button" onClick={fetchBanners} className={AD.btnSecondary}>
            Refresh
          </button>
          <button type="button" onClick={handleAddBanner} className={AD.btnPrimary}>
            Add banner
          </button>
        </div>
      </div>

      {/* Non-blocking error */}
      {error && (
        <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
          {error}
        </div>
      )}

      {/* Filters */}
      <div className={AD.filterCard}>
        <div className="grid gap-3 md:grid-cols-5">
          {/* Search */}
          <div className="md:col-span-2">
            <label className="block text-xs font-semibold text-slate-600 dark:text-slate-300">Search</label>
            <div className="relative mt-1">
              <input
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Search by title or type…"
                className={AD.input}
              />
              <svg
                className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
                width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8" /><path d="M21 21l-3.5-3.5" />
              </svg>
            </div>
          </div>

          {/* Type */}
          <Select
            label="Type"
            value={type}
            onChange={setType}
            options={typeOptions.map((t) => ({ label: t === "all" ? "All" : t, value: t }))}
          />

          {/* Status */}
          <Select
            label="Status"
            value={status}
            onChange={setStatus}
            options={[
              { label: "All", value: "all" },
              { label: "Active", value: "active" },
              { label: "Inactive", value: "inactive" },
            ]}
          />

          {/* Sort */}
          <Select
            label="Sort"
            value={sort}
            onChange={setSort}
            options={[
              { label: "Latest", value: "latest" },
              { label: "Oldest", value: "oldest" },
              { label: "A → Z", value: "az" },
              { label: "Z → A", value: "za" },
            ]}
          />
        </div>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {loading &&
          Array.from({ length: 6 }).map((_, i) => (
            <div key={`sk-${i}`} className="rounded-2xl border bg-white dark:bg-gray-900 dark:border-gray-800 p-4 animate-pulse">
              <div className="h-40 w-full rounded-xl bg-slate-200 dark:bg-gray-800" />
              <div className="mt-4 h-4 w-1/2 rounded bg-slate-200 dark:bg-gray-800" />
              <div className="mt-2 h-3 w-1/3 rounded bg-slate-200 dark:bg-gray-800" />
              <div className="mt-4 h-8 w-28 rounded-full bg-slate-200 dark:bg-gray-800" />
            </div>
          ))
        }

        {!loading && view.map((banner) => {
          const isBusy = busyId === banner._id;
          return (
            <div
              key={banner._id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-sm transition hover:shadow-md dark:border-gray-800 dark:bg-gray-900"
            >
              {/* Image */}
              <div className="relative">
                <div className="aspect-[16/9] w-full bg-slate-100 dark:bg-gray-800 overflow-hidden">
                  {banner?.imageUrl ? (
                    <img
                      src={banner.imageUrl}
                      alt={banner.title}
                      className="h-full w-full object-cover group-hover:scale-[1.02] transition-transform duration-300"
                    />
                  ) : (
                    <div className="grid h-full w-full place-items-center bg-slate-100 text-xs font-medium text-slate-400 dark:bg-gray-800 dark:text-slate-500">
                      No image
                    </div>
                  )}
                </div>

                {/* Status chip */}
                <div className="absolute left-3 top-3">
                  <span
                    className={cn(
                      "inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold shadow",
                      banner.isActive ? "bg-emerald-100 text-emerald-700" : "bg-rose-100 text-rose-700"
                    )}
                  >
                    <span className="h-1.5 w-1.5 rounded-full bg-current" />
                    {banner.isActive ? "Active" : "Inactive"}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-4 flex-1 flex flex-col">
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <h3 className="font-semibold text-slate-900 dark:text-white truncate">
                      {banner.title || "Untitled"}
                    </h3>
                    <div className="mt-1 text-xs text-slate-500 dark:text-slate-400 capitalize">
                      Type: {banner.type || "—"}
                    </div>
                  </div>

                  {/* Toggle */}
                  <label className="inline-flex items-center cursor-pointer select-none">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={!!banner.isActive}
                      onChange={() => handleToggleAsk(banner)}
                      disabled={isBusy}
                    />
                    <span className={cn(
                      "w-10 h-6 rounded-full transition-colors relative",
                      "peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-amber-300",
                      banner.isActive ? "bg-emerald-500/80" : "bg-slate-300"
                    )}>
                      <span className={cn(
                        "absolute top-0.5 left-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform",
                        banner.isActive ? "translate-x-4" : "translate-x-0"
                      )}/>
                    </span>
                  </label>
                </div>

                {/* Actions */}
                <div className="mt-4 flex items-center justify-end gap-2">
                  <button
                    type="button"
                    onClick={() => handleEdit(banner)}
                    className={`${AD.btnSecondary} py-1.5 text-xs`}
                    disabled={isBusy}
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    onClick={() => handleDelete(banner)}
                    className={`${AD.btnDanger} py-1.5 text-xs`}
                    disabled={isBusy}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          );
        })}

        {!loading && view.length === 0 && (
          <div className="col-span-full">
            <div className={AD.emptyState}>
              <p className="text-sm font-medium text-slate-700 dark:text-slate-300">
                No banners match your filters
              </p>
              <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
                Adjust search or add a new banner.
              </p>
              <button type="button" onClick={handleAddBanner} className={`${AD.btnPrimary} mt-5`}>
                Create banner
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Confirm Modal (Delete / Toggle) */}
      {confirm.open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setConfirm({ open: false, id: null, name: "", nextActive: false })}
          />
          <div className="relative w-full max-w-md rounded-2xl bg-white dark:bg-gray-900 border dark:border-gray-800 shadow-xl p-6 animate-[fadeIn_.2s_ease]">
            <h3 className="text-lg font-bold text-slate-900 dark:text-white">
              {confirm.nextActive === false && confirm.id ? "Confirm Deletion / Deactivation" : "Confirm Action"}
            </h3>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">
              {confirm.nextActive === false && confirm.id
                ? <>Do you want to <b>delete</b> or <b>deactivate</b> <b>{confirm.name}</b>?</>
                : <>Change status of <b>{confirm.name}</b> to <b>{confirm.nextActive ? "Active" : "Inactive"}</b>?</>}
            </p>

            <div className="mt-6 grid grid-cols-2 gap-2">
              {/* If this came from delete, show a red Delete too */}
              {confirm.nextActive === false && (
                <button
                  onClick={confirmDelete}
                  className="rounded-full bg-rose-600 text-white px-4 py-2 text-sm font-semibold hover:bg-rose-700"
                >
                  Delete
                </button>
              )}
              <button
                onClick={confirmToggle}
                className="rounded-full bg-amber-500 text-white px-4 py-2 text-sm font-semibold hover:bg-amber-600"
              >
                {confirm.nextActive ? "Activate" : "Deactivate"}
              </button>
              <button
                onClick={() => setConfirm({ open: false, id: null, name: "", nextActive: false })}
                className="col-span-2 rounded-full border px-4 py-2 text-sm font-semibold hover:bg-amber-50 dark:hover:bg-gray-800"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* tiny reusable */
function Select({ label, value, onChange, options }) {
  return (
    <label className="block">
      <div className="text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1">{label}</div>
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={AD.select}
        >
          {options.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
        <svg
          className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-slate-400"
          width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </div>
    </label>
  );
}
